var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogPendingApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552.354909 353.559273v189.998545l179.712 98.583273a34.909091 34.909091 0 0 1-33.512727 61.207273l-197.864727-108.497455a34.909091 34.909091 0 0 1-18.152728-30.580364V353.559273a34.909091 34.909091 0 0 1 69.818182 0z m376.971636 263.028363a34.722909 34.722909 0 0 0-43.473454 23.365819 377.204364 377.204364 0 0 1-94.301091 157.370181c-146.897455 146.944-385.861818 146.897455-532.759273 0a374.132364 374.132364 0 0 1-110.359272-266.379636A374.225455 374.225455 0 0 1 258.792727 264.517818a374.178909 374.178909 0 0 1 266.426182-110.359273c77.451636 0 151.226182 23.412364 213.597091 66.606546h-83.362909a34.909091 34.909091 0 0 0 0 69.818182h174.266182a34.909091 34.909091 0 0 0 34.909091-34.909091V81.454545a34.909091 34.909091 0 0 0-69.818182 0v94.068364a442.414545 442.414545 0 0 0-269.591273-91.136A443.392 443.392 0 0 0 209.454545 215.226182a443.485091 443.485091 0 0 0-130.839272 315.764363c0 119.296 46.452364 231.424 130.839272 315.717819a443.392 443.392 0 0 0 315.764364 130.792727 443.438545 443.438545 0 0 0 315.717818-130.792727 447.255273 447.255273 0 0 0 111.755637-186.647273 34.862545 34.862545 0 0 0-23.365819-43.473455z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogPendingApproval);
export default __webpack_public_path__ + "static/media/Log-PendingApproval.8dfe83a8703ab03f6d19c2e7e9dc33e5.svg";
export { ForwardRef as ReactComponent };